// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchBar_searchContainer__HFSuT {
    display: flex;
    max-width: 600px;
    margin: 20px auto;
    position: relative;
    direction: rtl;
    width: 100%;
}

.SearchBar_searchInput__lAK8w {
    width: 100%;
    padding: 12px 50px 12px 20px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 30px;
    font-size: 16px;
    outline: none;
    transition: all 0.3s ease;
    text-align: right;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    color: #333;
    -webkit-backdrop-filter: blur(10px);
}

.SearchBar_searchInput__lAK8w:focus {
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
}

.SearchBar_searchInput__lAK8w::placeholder {
    color: rgba(51, 51, 51, 0.7);
    font-size: 14px;
}

.SearchBar_searchButton__jy7Bv {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: all 0.3s ease;
    backdrop-filter: blur(5px);
}

.SearchBar_searchButton__jy7Bv:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-50%) scale(1.05);
}

.SearchBar_searchIcon__hkE5w {
    width: 24px;
    height: 24px;
    fill: #333;
    transition: fill 0.3s ease;
}

.SearchBar_searchButton__jy7Bv:hover .SearchBar_searchIcon__hkE5w {
    fill: #015933;
}

/* Tablet and medium  */
@media (max-width: 1024px) {
    .SearchBar_searchContainer__HFSuT {
        width: 150px;
        margin: 15px auto;
    }
    
    .SearchBar_searchInput__lAK8w {
        padding: 10px 45px 10px 18px;
        font-size: 15px;
        border-radius: 25px;
    }
    
    .SearchBar_searchInput__lAK8w::placeholder {
        font-size: 13px;
    }
    
    .SearchBar_searchButton__jy7Bv {
        left: 8px;
        padding: 7px;
    }
    
    .SearchBar_searchIcon__hkE5w {
        width: 22px;
        height: 22px;
    }
}

@media (max-width: 850px) and (min-width: 769px) {
    .SearchBar_searchContainer__HFSuT {
        max-width: 350px;
        margin: 12px auto;
    }
    
    .SearchBar_searchInput__lAK8w {
        padding: 9px 42px 9px 16px;
        font-size: 14px;
        border-radius: 22px;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
    }
    
    .SearchBar_searchInput__lAK8w:focus {
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
    }
    
    .SearchBar_searchInput__lAK8w::placeholder {
        font-size: 12px;
    }
    
    .SearchBar_searchButton__jy7Bv {
        left: 6px;
        padding: 6px;
    }
    
    .SearchBar_searchIcon__hkE5w {
        width: 20px;
        height: 20px;
    }
}

/* phone styles for search in menu */
@media (max-width: 768px) {
    .SearchBar_searchContainer__HFSuT {
        max-width: 100%;
        margin: 0;
        width: 100%;
    }
    
    .SearchBar_searchInput__lAK8w {
        padding: 14px 45px 14px 15px;
        font-size: 16px;
        border-radius: 25px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .SearchBar_searchInput__lAK8w:focus {
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
    }
    
    .SearchBar_searchInput__lAK8w::placeholder {
        font-size: 14px;
        color: rgba(51, 51, 51, 0.7);
    }
    
    .SearchBar_searchButton__jy7Bv {
        left: 8px;
        padding: 6px;
        background: rgba(255, 255, 255, 0.25);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }
    
    .SearchBar_searchButton__jy7Bv:hover {
        background: rgba(255, 255, 255, 0.35);
    }
    
    .SearchBar_searchIcon__hkE5w {
        width: 20px;
        height: 20px;
    }
}

/* Small phone devices */
@media (max-width: 480px) {
    .SearchBar_searchInput__lAK8w {
        padding: 12px 40px 12px 12px;
        font-size: 15px;
    }
    
    .SearchBar_searchInput__lAK8w::placeholder {
        font-size: 13px;
    }
    
    .SearchBar_searchButton__jy7Bv {
        left: 6px;
        padding: 5px;
    }
    
    .SearchBar_searchIcon__hkE5w {
        width: 18px;
        height: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Search bars/SearchBar.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,qCAAqC;IACrC,2BAA2B;IAC3B,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;IACtC,8CAA8C;IAC9C,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,0CAA0C;IAC1C,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;QAC5B,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,eAAe;QACf,mBAAmB;QACnB,oCAAoC;QACpC,2BAA2B;QAC3B,mCAAmC;IACvC;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;QAC3B,mCAAmC;IACvC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,eAAe;QACf,SAAS;QACT,WAAW;IACf;;IAEA;QACI,4BAA4B;QAC5B,eAAe;QACf,mBAAmB;QACnB,0CAA0C;QAC1C,oCAAoC;QACpC,2BAA2B;QAC3B,mCAAmC;QACnC,wCAAwC;IAC5C;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;QAC3B,mCAAmC;QACnC,+CAA+C;QAC/C,sCAAsC;IAC1C;;IAEA;QACI,eAAe;QACf,4BAA4B;IAChC;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,qCAAqC;QACrC,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".searchContainer {\r\n    display: flex;\r\n    max-width: 600px;\r\n    margin: 20px auto;\r\n    position: relative;\r\n    direction: rtl;\r\n    width: 100%;\r\n}\r\n\r\n.searchInput {\r\n    width: 100%;\r\n    padding: 12px 50px 12px 20px;\r\n    border: 2px solid rgba(255, 255, 255, 0.2);\r\n    border-radius: 30px;\r\n    font-size: 16px;\r\n    outline: none;\r\n    transition: all 0.3s ease;\r\n    text-align: right;\r\n    box-sizing: border-box;\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(10px);\r\n    color: #333;\r\n    -webkit-backdrop-filter: blur(10px);\r\n}\r\n\r\n.searchInput:focus {\r\n    border-color: rgba(255, 255, 255, 0.4);\r\n    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);\r\n    background: rgba(255, 255, 255, 0.25);\r\n    backdrop-filter: blur(15px);\r\n    -webkit-backdrop-filter: blur(15px);\r\n}\r\n\r\n.searchInput::placeholder {\r\n    color: rgba(51, 51, 51, 0.7);\r\n    font-size: 14px;\r\n}\r\n\r\n.searchButton {\r\n    position: absolute;\r\n    left: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border: 1px solid rgba(255, 255, 255, 0.1);\r\n    cursor: pointer;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    transition: all 0.3s ease;\r\n    backdrop-filter: blur(5px);\r\n}\r\n\r\n.searchButton:hover {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    border-color: rgba(255, 255, 255, 0.2);\r\n    transform: translateY(-50%) scale(1.05);\r\n}\r\n\r\n.searchIcon {\r\n    width: 24px;\r\n    height: 24px;\r\n    fill: #333;\r\n    transition: fill 0.3s ease;\r\n}\r\n\r\n.searchButton:hover .searchIcon {\r\n    fill: #015933;\r\n}\r\n\r\n/* Tablet and medium  */\r\n@media (max-width: 1024px) {\r\n    .searchContainer {\r\n        width: 150px;\r\n        margin: 15px auto;\r\n    }\r\n    \r\n    .searchInput {\r\n        padding: 10px 45px 10px 18px;\r\n        font-size: 15px;\r\n        border-radius: 25px;\r\n    }\r\n    \r\n    .searchInput::placeholder {\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .searchButton {\r\n        left: 8px;\r\n        padding: 7px;\r\n    }\r\n    \r\n    .searchIcon {\r\n        width: 22px;\r\n        height: 22px;\r\n    }\r\n}\r\n\r\n@media (max-width: 850px) and (min-width: 769px) {\r\n    .searchContainer {\r\n        max-width: 350px;\r\n        margin: 12px auto;\r\n    }\r\n    \r\n    .searchInput {\r\n        padding: 9px 42px 9px 16px;\r\n        font-size: 14px;\r\n        border-radius: 22px;\r\n        background: rgba(255, 255, 255, 0.2);\r\n        backdrop-filter: blur(12px);\r\n        -webkit-backdrop-filter: blur(12px);\r\n    }\r\n    \r\n    .searchInput:focus {\r\n        background: rgba(255, 255, 255, 0.3);\r\n        backdrop-filter: blur(16px);\r\n        -webkit-backdrop-filter: blur(16px);\r\n    }\r\n    \r\n    .searchInput::placeholder {\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .searchButton {\r\n        left: 6px;\r\n        padding: 6px;\r\n    }\r\n    \r\n    .searchIcon {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n}\r\n\r\n/* phone styles for search in menu */\r\n@media (max-width: 768px) {\r\n    .searchContainer {\r\n        max-width: 100%;\r\n        margin: 0;\r\n        width: 100%;\r\n    }\r\n    \r\n    .searchInput {\r\n        padding: 14px 45px 14px 15px;\r\n        font-size: 16px;\r\n        border-radius: 25px;\r\n        border: 1px solid rgba(255, 255, 255, 0.2);\r\n        background: rgba(255, 255, 255, 0.2);\r\n        backdrop-filter: blur(10px);\r\n        -webkit-backdrop-filter: blur(10px);\r\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .searchInput:focus {\r\n        background: rgba(255, 255, 255, 0.3);\r\n        backdrop-filter: blur(15px);\r\n        -webkit-backdrop-filter: blur(15px);\r\n        box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);\r\n        border-color: rgba(255, 255, 255, 0.3);\r\n    }\r\n    \r\n    .searchInput::placeholder {\r\n        font-size: 14px;\r\n        color: rgba(51, 51, 51, 0.7);\r\n    }\r\n    \r\n    .searchButton {\r\n        left: 8px;\r\n        padding: 6px;\r\n        background: rgba(255, 255, 255, 0.25);\r\n        backdrop-filter: blur(8px);\r\n        -webkit-backdrop-filter: blur(8px);\r\n    }\r\n    \r\n    .searchButton:hover {\r\n        background: rgba(255, 255, 255, 0.35);\r\n    }\r\n    \r\n    .searchIcon {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n}\r\n\r\n/* Small phone devices */\r\n@media (max-width: 480px) {\r\n    .searchInput {\r\n        padding: 12px 40px 12px 12px;\r\n        font-size: 15px;\r\n    }\r\n    \r\n    .searchInput::placeholder {\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .searchButton {\r\n        left: 6px;\r\n        padding: 5px;\r\n    }\r\n    \r\n    .searchIcon {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `SearchBar_searchContainer__HFSuT`,
	"searchInput": `SearchBar_searchInput__lAK8w`,
	"searchButton": `SearchBar_searchButton__jy7Bv`,
	"searchIcon": `SearchBar_searchIcon__hkE5w`
};
export default ___CSS_LOADER_EXPORT___;
